import React from "react";

import {
  IconSnowflake,
  IconWifi,
  IconSeatedPassenger,
  IconHotDrink,
  IconLuggage,
  IconWifiTV,
  IconTV,
  IconUtensils,
  IconArmchair,
  IconPowerOutlet,
  IconToilet,
  IconSilence,
  IconReservedSeat,
  IconSeatSize,
  IconApple,
  IconWheelchair,
  IconQrCode,
  mergeClasses
} from "@busbud/horizon";

import { DISPLAYABLE_AMENITIES } from "../../helpers/amenities";

type Props = {
  amenity_key: string;
  size: "sm" | "md" | "lg";
  className?: string;
};

export const AmenityIcon: React.FC<Props> = ({
  amenity_key,
  size,
  className
}) => {
  const commonIconProps = {
    className: mergeClasses("text-icon-color-primary", className), // use mergeClasses to allow for overiding icon color
    size
  } as const;

  switch (amenity_key) {
    case DISPLAYABLE_AMENITIES.AC:
      return <IconSnowflake variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.AVERAGE_SEAT:
      return <IconSeatedPassenger variant="small" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.CAFE:
      return <IconHotDrink variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.CHECKED_BAGGAGE:
      return <IconLuggage variant="single" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.DRINK:
      return <IconHotDrink variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.ENTERTAINMENT_AND_WIFI:
      return <IconWifiTV {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.ENTERTAINMENT:
      return <IconTV {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.FULL_RECLINE_SEAT:
      return <IconSeatedPassenger variant="fullRecline" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.HOT_MEAL:
      return <IconUtensils variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.LOUNGE_ACCESS:
      return <IconArmchair {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.NO_AC:
      return <IconSnowflake variant="strikethrough" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.NO_POWER_OUTLETS:
      return <IconPowerOutlet variant="strikethrough" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.NO_TOILET:
      return <IconToilet variant="strikethrough" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.NO_WIFI:
      return <IconWifi variant="strikethrough" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.POWER_OUTLETS:
      return <IconPowerOutlet variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.QUIET_ZONE:
      return <IconSilence {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.RESERVED_SEATS:
      return <IconReservedSeat {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.RESTAURANT:
      return <IconUtensils variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.SMALL_SEAT:
      return <IconSeatSize {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.SNACK:
      return <IconApple {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.TOILET:
      return <IconToilet variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.TRAY_MEAL:
      return <IconUtensils variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.TWO_PLUS_ONE:
      return <IconSeatedPassenger variant="small" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.TWO_PLUS_TWO:
      return <IconSeatedPassenger variant="small" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.WHEELCHAIR_RAMP:
      return <IconWheelchair {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.WIFI:
      return <IconWifi variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.XL_SEAT:
      return <IconSeatedPassenger variant="xlarge" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.E_TICKET:
      return <IconQrCode variant="default" {...commonIconProps} />;
    case DISPLAYABLE_AMENITIES.NO_E_TICKET:
      return <IconQrCode variant="strikethrough" {...commonIconProps} />;
    default:
      return null;
  }
};
